import { useEffect, useRef } from 'react';
import {
  getPiezoInitFailure,
  onPiezoInitStatusChange,
} from '../../../client/piezo/provisioning/initStatus';
import {
  isMidwaySessionExpired,
  MIDWAY_EXPIRED_MESSAGE,
  onMidwaySessionChange,
} from '../../../client/piezo/signing/midwaySession';
import { isPiezoEnabledEnvironment } from '../../../client/piezo/signing/environment';
import { useToastNotifications } from '../../../hooks/useToastList';

/**
 * Raises a toast when Piezo provisioning fails, so the operator learns it at page load rather than from the
 * first tool call that fails. Renders nothing; the navbar carries only the actions.
 */
export const PiezoStatusNotifier = () => {
  const toasts = useToastNotifications();
  /** The last message raised, so a re-provision attempt per tool call does not raise a toast each time. */
  const lastRaised = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!isPiezoEnabledEnvironment()) {
      return undefined;
    }
    const read = () => {
      const message = isMidwaySessionExpired() ? MIDWAY_EXPIRED_MESSAGE : getPiezoInitFailure();
      if (!message) {
        lastRaised.current = undefined;
        return;
      }
      if (message === lastRaised.current) {
        return;
      }
      lastRaised.current = message;
      toasts.addDanger(message);
    };
    read();
    const stopInit = onPiezoInitStatusChange(read);
    const stopMidway = onMidwaySessionChange(read);
    return () => {
      stopInit();
      stopMidway();
    };
  }, [toasts]);

  return null;
};
